import axios from '../axios';

const fetchBroadcasts = async (botId: string) => {
  const { data } = await axios.get(`/broadcasts/${botId}`);

  return data;
};

export default fetchBroadcasts;
